import { render, staticRenderFns } from "./InvestPublicDetails.vue?vue&type=template&id=5ad8285d&scoped=true&"
import script from "./InvestPublicDetails.vue?vue&type=script&lang=js&"
export * from "./InvestPublicDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad8285d",
  null
  
)

export default component.exports